//App entrypoint
import "./assets/scripts/main.js";
import "./assets/scripts/news.js";
import "./assets/scripts/resources.js";
import "./assets/scripts/contact.js";
